import { ErrorContentGenerator, ErrorContentMap, InvalidFieldMessages } from "./getAlertContent";
import { MfaVerifyPasswordProps, PasswordFields } from "../../components/SmartErrorAlert";
import { serviceError } from "./mfaEnrollStep1Errors";
import translate from "../translate";

export type MfaVerifyPasswordErrorState = "TOO_MANY_ATTEMPTS" | "UNKNOWN";

export const errorContent: ErrorContentMap<MfaVerifyPasswordErrorState> = {
    TOO_MANY_ATTEMPTS: {
        header: translate("your_password_does_not_match"),
        body: <>
            <p className="ds-u-margin-top--0 ds-u-margin-bottom--0">{translate("verify_password_alert_body")}</p>
        </>,
        analyticsErr: "Your password doesn't match our records. You have 1 more try to re-enter your password. If it doesn't match our records, your account will be locked for 1 hour."
    },
    UNKNOWN: serviceError
}

const invalidFieldMessages: InvalidFieldMessages<PasswordFields> = {
    password: {
        linkText: 'password',
        messages: {
            empty: 'verify_password_field_error'
        }
    }
}

export const mfaVerifyPasswordErrorFns = new ErrorContentGenerator<MfaVerifyPasswordProps, PasswordFields, MfaVerifyPasswordErrorState>({
    apiErrorContent: errorContent,
    invalidFieldHeader: "none", // No validation alerts for this step, so this isn't actually used
    getRefMap: props => {
        return {
            password: props.passwordRef
        }
    },
    getErrState,
    invalidFieldMessages,
    getApiInvalidFields: () => [],
    isIntermediateStep: false
});


function getErrState(apiResponse: {} | null, errorKey?: string) {
    if (errorKey === 'TOO_MANY_ATTEMPTS' || errorKey === 'UNKNOWN') {
        return errorKey;
    } else {
        return null;
    }
}
